import type { LandingImage } from '@/components/interior-landing/assets';
import type { LandingFaq } from '@/components/interior-landing/types';

/** The rooms every guide shows its style on (the landing pages' sample photos). */
export const GUIDE_ROOMS = ['living-room', 'bedroom', 'kitchen'] as const;
export type GuideRoom = (typeof GUIDE_ROOMS)[number];

/**
 * One interior design style guide (/interior-design-styles/<slug>). English
 * only: the guides are written for English searches.
 */
export interface StyleGuide {
  /** URL slug, also the name of the guide's images (guides/<slug>-<room>). */
  slug: string;
  /** Display name, e.g. "Mid-Century Modern". */
  name: string;
  /** The AI Interior Designer style the guide's buttons open with. */
  toolStyle: string;
  /** Title tag without the brand (Seo adds it), at most 60 characters. */
  seoTitle: string;
  seoDescription: string;
  /** Short line in the hero's eyebrow and on the guide's card. */
  tagline: string;
  /** What the style is, in one or two sentences (the hero's lead). */
  definition: string;
  /** "What is <name>?" paragraphs: where it comes from and what it values. */
  intro: string[];
  palette: { name: string; hex: string; use: string }[];
  paletteNote: string;
  materials: string[];
  elements: { title: string; body: string }[];
  /** Three tips per room, shown next to the room in this style. */
  rooms: Record<GuideRoom, string[]>;
  avoid: string[];
  /** How it differs from similar styles (`slug` links to that guide). */
  versus: { name: string; slug?: string; body: string }[];
  faqs: LandingFaq[];
  /** Slugs of guides to read next. */
  related: string[];
}

/** A guide as a link: its name, tagline and living room picture. */
export interface StyleGuideCard {
  slug: string;
  name: string;
  tagline: string;
  image: LandingImage;
}
